/* eslint-disable no-underscore-dangle */
/* eslint-disable consistent-return */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import MaterialTable from 'material-table';
import userServices from '../../../../redux/services/userServices';

const StudentsInGroupList = ({
  group, students, subGroupId, removeStudentToGroup,
}) => (
  <MaterialTable
    title="Sous-groupe"
    data={students}
    style={{
      width: '48%',
      height: '100%',
      zIndex: 0,
    }}
    columns={[
      {
        title: 'Last name',
        field: 'name',
      },
      {
        title: 'First name',
        field: 'firstname',
      },
      {
        title: 'Email',
        field: 'email',
        render: (rowData) => `${rowData.email.slice(0, 16)}${rowData.email.length > 16 ? '..' : ''}`,
      },
    ]}
    options={{
      selection: true,
      pageSize: 10,
    }}
    actions={[
      {
        icon: 'remove',
        tooltip: 'remove students from subgroup',
        onClick: (event, rowData) => {
          const res = [];
          rowData.forEach((student) => {
            res.push(student._id);
          });
          userServices.deleteUsersFromSubGroup(group._id, subGroupId, res)
            .then(() => {
              removeStudentToGroup(subGroupId, res);
            });
        },
      },
    ]}
  />
);

StudentsInGroupList.propTypes = {
  students: PropTypes.array.isRequired,
  subGroupId: PropTypes.string.isRequired,
  group: PropTypes.object.isRequired,
  removeStudentToGroup: PropTypes.func.isRequired,
};

export default StudentsInGroupList;
